import React, { Fragment } from 'react';
import { Button } from 'Components/frameworks/button/Button';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Modal } from 'Components/frameworks/modal/Modal';
import { ICONS } from 'Components/utils/icon/icons';
import { ID_MODAL_HEADER__BE__OPTION } from 'Components/utils/identifiers/constants';
import { t } from 'Src/i18n';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
type Props = {
  imageUrl?: string;
  proposalId: string;
  onClose: () => void;
  onClick: () => void;
  isOptionAllowed?: boolean;
  optionDuration: any;
  disclaimer: string;
};
export const OptionModal = ({
  imageUrl,
  proposalId,
  onClose,
  onClick,
  isOptionAllowed = false,
  optionDuration,
  disclaimer,
}: Props) => {
  return (
    <Modal
      ariaLabel={t(
        isOptionAllowed ? 'booking.option.popin.header' : 'booking.callCenterPopIn.title',
      )}
      ariaLabelledby={ID_MODAL_HEADER__BE__OPTION}
      closeLabel={t('common.close')}
      onClose={onClose}
    >
      <div className="overflow-hidden" data-testid="SummaryView-optionModal">
        <div className="relative h-228 overflow-hidden">
          {!!imageUrl && <img src={imageUrl} className="w-full" alt="" />}

          <div className="absolute inset-0 flex items-center justify-center">
            <Icon className="text-white" hasRtl name={ICONS.CALENDAR_OPTION} width="7rem" />
          </div>
        </div>

        <div className="m-25 text-center">
          <div id={ID_MODAL_HEADER__BE__OPTION} className="mb-10 font-brand text-24 text-black">
            {t(isOptionAllowed ? 'booking.option.popin.header' : 'booking.callCenterPopIn.title')}
          </div>
          {isOptionAllowed ? (
            <div className="mb-5 flex flex-col justify-center">
              <div className="p-10 text-16">
                {t('booking.option.popinDescription')}
                {disclaimer}
              </div>
              {optionDuration && (
                <p className="m-auto max-w-280 p-10 text-16">
                  <TemplateString
                    dataTestId="optionEndDate"
                    className="font-bold text-sienna"
                    template={t('booking.summary.optionDuration')}
                    values={{
                      duration: optionDuration,
                    }}
                  />
                </p>
              )}
            </div>
          ) : (
            <Fragment>
              <p className="mb-10 inline-flex items-center rounded-12 border-2 border-sienna p-10 text-sienna">
                <Icon name={ICONS.PHONE_BUBBLE} width="2em" />
                <span className="block font-bold"> {t('booking.callCenterPopIn.number')}</span>
              </p>
              <span className="block text-10 text-black">{t('booking.callCenterPopIn.cost')}</span>
              <div className="p-10 text-16">{t('booking.callCenterPopIn.useProposalIdLabel')}</div>
            </Fragment>
          )}

          <Button
            className="mb-15 mt-30 min-w-200"
            data-testid="pauseOptionModalButton"
            onClick={onClick}
          >
            {t('booking.option.buttonLabel')}
          </Button>
          <div className="font-bold">
            {t('common.reference')} : {proposalId}
          </div>
        </div>
      </div>
    </Modal>
  );
};
